<script setup lang="ts">
import Skeleton from '@/shared/ui/Skeleton/index';

const isMobile: boolean = useIsMobile();
</script>

<template>
  <div :class="['feedbacks-section-skeleton', { _mobile: isMobile }]">
    <Skeleton
      :width="isMobile ? '100%' : '362px'"
      :height="isMobile ? '168px' : '60px'"
    />
    <ul v-if="!isMobile" class="feedbacks-section-skeleton__list">
      <li>
        <Skeleton width="100%" height="135px" />
      </li>
      <li>
        <Skeleton width="367px" height="71px" />
      </li>
      <li>
        <Skeleton width="100%" height="60px" />
      </li>
    </ul>
    <Skeleton
      :class="['feedbacks-section-skeleton__button', { _mobile: isMobile }]"
      :width="isMobile ? '100%' : '235px'"
      height="45px"
    />
  </div>
</template>

<style lang="less" scoped>
.feedbacks-section-skeleton {
  .flex-column(@size-x10);
  .box-shadow();

  padding: @size-x8;

  &__list {
    .flex-column(@size-x6);
  }

  &._mobile {
    padding: @size-x5;
  }

  &__button:not(._mobile) {
    margin-left: auto;
  }
}
</style>
